<template>
  <div class="container">
    <!--  -->
    <div class="zhw-goods">
      <div class="index_4_orderby_search">
        <div class="index_4_orderby_list">
          <ul>
            <a-row :gutter="10">
              <a-col :span="15">
                <li
                  style="
                    color: #606266;
                    font-weight: 700;
                    text-align: left;
                    margin-left: 15px;
                  "
                >
                  商品名称
                </li>
              </a-col>
              <a-col :span="3">
                <li style="color: #606266; font-weight: 700">零售价</li>
              </a-col>
              <a-col :span="3">
                <li style="color: #606266; font-weight: 700">库存</li>
              </a-col>
              <a-col :span="3">
                <li style="color: #606266; font-weight: 700">操作</li>
              </a-col>
            </a-row>
          </ul>
        </div>
      </div>

      <a-spin :spinning="loadingState">
        <div
          class="index_4_goods_wrap index_4_goods_wrap202306"
          style="min-height: 400px; background-color: #ffffff"
        >
          <div
            class="index_4_goods_box"
            v-for="(item, index) in catesList"
            :key="index"
          >
            <div class="index_4_goods_list">
              <div style="background-color: #f2f2f2; padding: 12px 0px">
                <div
                  style="text-align: center; font-size: 15px; font-weight: 600"
                >
                  <span id="">{{ item.categoryName }}</span>
                </div>
              </div>

              <ul>
                <li
                  v-for="(item, k, i) in item.productList"
                  :key="i"
                  @click="toProductDetails(item)"
                  style="padding: 20px 0px 20px 15px; align-items: center"
                >
                  <a-row>
                    <a-col :span="15">
                      <div class="goods-img" style="display: flex">
                        <div class="list-img">
                          <img class="table-img" :src="item.picUrl" alt="" />
                        </div>

                        <div class="goods-info">
                          <div class="goods-title">
                            <span class="goods-title-con">
                              {{ item.productName }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="3">
                      <div class="index_4_goods-price">
                        <div class="index_4_goods-price-nei">
                          <div class="price-rent">
                            {{ item.price }}
                            <span class="price-symbol"> 元</span>
                          </div>
                          <div style="text-align: center">已售20</div>
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="3">
                      <div style="line-height: 40px; text-align: center">
                        <a-tag color="#f34a4b"> 10 </a-tag>
                      </div>
                    </a-col>
                    <a-col :span="3">
                      <div
                        class="goods-control"
                        style="line-height: 40px; text-align: center"
                      >
                        <button
                          class="btn-all"
                          style="background-color: #ffffff"
                        >
                          立即购买
                        </button>
                      </div>
                    </a-col>
                  </a-row>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </a-spin>
    </div>
  </div>
</template>
<script>
import { queryProductListByCategoryPid } from "@/api/product";

export default {
  data() {
    return {
      loadingState: true,
      catesList: [],
    };
  },
  created() {
    this.getProductList();
  },

  methods: {
    //查询商品列表
    getProductList() {
      queryProductListByCategoryPid({})
        .then((res) => {
          this.catesList = res.result;
          this.loadingState = false;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    //跳转商品详情界面
    toProductDetails(v) {
      this.$router.push(`/pgoodsDetail/${v.id}`);
    },
  },
};
</script>
<style scoped>
.zhw-main {
  position: relative;
  margin-top: 24px;
}

.zhw-goods {
  margin-top: 10px;
}

.index_4_orderby_search {
  height: 52px;
  line-height: 52px;
  text-align: center;
  vertical-align: middle;
  border-left: 0;
  border-right: 0;
  background-color: #fff;
  font-size: 15px;
}

.index_4_orderby_search .index_4_orderby_list ul li span.order-up {
  width: 9px;
  height: 12px;
  margin-left: 8px;
  background-position: -14px -32px;
}

.index_4_orderby_search .index_4_orderby_list ul li span.order-down {
  width: 9px;
  height: 12px;
  margin-left: 8px;
  background-position: -32px -32px;
  top: 1px;
}

.index_4_orderby_search .index_4_orderby_list ul li.cur span.order-up,
.index_4_orderby_search .index_4_orderby_list ul li:hover span.order-up {
  width: 9px;
  height: 12px;
  margin-left: 8px;
  background-position: -56px -32px;
}

.index_4_orderby_search .index_4_orderby_list ul li.cur span.order-down,
.index_4_orderby_search .index_4_orderby_list ul li:hover span.order-down {
  width: 9px;
  height: 12px;
  margin-left: 8px;
  background-position: -75px -32px;
  top: 1px;
}

.index_4_orderby_search .index_4_orderby_list ul li.cur,
.index_4_orderby_search .index_4_orderby_list ul li:hover {
  color: #000000;
  /* background: #fc3737; */
  border-radius: 8px;
  font-weight: 600;
}

.index_4_orderby_search .index_4_orderby_list ul li.rentZQ a {
  color: #787878;
}

.index_4_orderby_search .index_4_orderby_list ul li:hover a {
  color: #fff;
}

.index_4_goods_wrap {
  position: relative;
}

.index_4_goods_wrap .index_4_goods_box {
  display: flex;
}

.index_4_goods_wrap .index_4_goods_list {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  max-width: 100%;
}

.index_4_goods_wrap .index_4_goods_list > ul > li {
  border-bottom: 1px solid #f4f4f4;
  position: relative;
}

.index_4_goods_wrap .index_4_goods_list > ul > li.yx-disabled button {
  background: #999;
  color: #fff;
  border: 1px solid #999;
}

.index_4_goods_wrap .index_4_goods_list > ul > li.ad-li > a {
  padding: 0;
  position: relative;
  overflow: hidden;
  height: 136px;
}

.index_4_goods_wrap .index_4_goods_list > ul > li.ad-li .ad-img {
  position: absolute;
  left: 0;
  top: 0;
  height: 136px;
  max-width: 100%;
}

.index_4_goods_wrap .index_4_goods_list > ul > li > a {
  display: block;
  padding: 20px 0;
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  align-items: center;
  background-color: #fff;
  -webkit-transition: background-color 0.2s;
  -moz-transition: background-color 0.2s;
  transition: background-color 0.2s;
  -ms-flex-align: center;
}

.index_4_goods_wrap .index_4_goods_list > ul > li > a:hover {
  background-color: #fafafa;
}

.index_4_goods_wrap .index_4_goods_list > ul > li .feedback-shade-de .title {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333;
  padding-left: 42px;
  position: relative;
  height: 22px;
  line-height: 22px;
  margin-top: 22px;
}

.index_4_goods_wrap
  .index_4_goods_list
  > ul
  > li
  .feedback-shade-de
  .title:first-child {
  margin-top: 0;
}

.index_4_goods_wrap
  .index_4_goods_list
  > ul
  > li
  .feedback-shade-de
  .title:after {
  position: absolute;
  content: "";
  width: 24px;
  height: 24px;
  top: 0;
  left: 8px;
}

.index_4_goods_wrap
  .index_4_goods_list
  > ul
  > li
  .feedback-shade-de
  .feedback-de {
  margin-top: 4px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.index_4_goods_wrap
  .index_4_goods_list
  > ul
  > li
  .feedback-shade-de
  .feedback-de
  .item {
  height: 32px;
  color: #333;
  background: #f2f3f9;
  border-radius: 31px;
  line-height: 32px;
  padding-left: 10px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding-right: 10px;
  margin-top: 8px;
  margin-left: 8px;
  cursor: pointer;
}

.index_4_goods_wrap
  .index_4_goods_list
  > ul
  > li
  .feedback-shade-de
  .feedback-de
  .item
  .type {
  width: auto;
  height: 100%;
}

.index_4_goods_wrap
  .index_4_goods_list
  .is_recommend_item
  .is_recommend_item_title {
  position: absolute;
  top: 11px;
  left: 20px;
  font-size: 16px;
  font-weight: 700;
  color: #262626;
}

.index_4_goods_wrap
  .index_4_goods_list
  .is_recommend_item
  .recommend-close-shade-de {
  width: 154px;
  height: 104px;
  background: #fff;
  -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 39px;
  right: 4px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 4px 16px;
  border-radius: 5px;
  display: none;
}

.index_4_goods_wrap .goods-img .list-img {
  display: block;
  width: 40px;
  height: 40px;
  position: relative;
  margin-left: 23px;
}

.index_4_goods_wrap .goods-img .table-img {
  display: block;
  width: 40px;
  height: 40px;
  -o-object-fit: cover;
  object-fit: cover;
}

.index_4_goods_wrap .goods-img .table-img.height_90 {
  height: 90px !important;
}

.index_4_goods_wrap .goods-img .table-img.height_100 {
  height: 100px !important;
}

.index_4_goods_wrap .goods-img .phone-system-icon {
  position: absolute;
  left: 0;
  top: 0;
}

.index_4_goods_wrap .goods-title-con {
  display: inline-block;
  max-width: 374px;
  font-size: 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: middle;
}

.index_4_goods_wrap .account-tag,
.index_4_goods_wrap .android-tag,
.index_4_goods_wrap .domestic-tag,
.index_4_goods_wrap .international-tag,
.index_4_goods_wrap .ios-tag {
  color: #fff;
  font-size: 12px;
  border-radius: 2px;
  line-height: 16px;
  margin-right: 6px;
  padding: 0 6px 1px;
  vertical-align: middle;
  display: inline-block;
}

.index_4_goods_wrap .android-tag {
  background-color: #329c22;
}

.index_4_goods_wrap .ios-tag {
  background-color: #d96a29;
}

.index_4_goods_wrap .international-tag {
  background-color: #296ad9;
}

.index_4_goods_wrap .domestic-tag {
  background-color: #4d4d4d;
}

.index_4_goods_wrap .account-tag {
  display: inline-block;
  background: #ff893d;
}

.index_4_goods_wrap .goods-rent-times {
  line-height: 1;
  margin-top: 5px;
}

.index_4_goods_wrap .goods-rent-times span {
  font-size: 12px;
  color: #888;
}

.index_4_goods_wrap .goods-rent-times .skin {
  display: none;
}

.index_4_goods_wrap .index_4_goods-price {
  text-align: center;
  line-height: 1;
  font-size: 12px;
  font-weight: 400;
  color: #8b8b8b;
}

.index_4_goods_wrap .index_4_goods-price .price-sale {
  font-size: 18px;
  color: #fc3737;
  font-weight: 700;
  margin-right: 5px;
}

.index_4_goods_wrap .index_4_goods-price .price-hyphen {
  text-decoration: line-through;
}

.index_4_goods_wrap .index_4_goods-price .price-rent {
  font-weight: 700;
  color: #fc3737;
  font-size: 14px;
}

.index_4_goods_wrap .index_4_goods-price .price-rent .limit_full_reduction {
  padding: 2px 4px;
  background: #ff2424;
  font-size: 12px;
  font-weight: 400;
  color: #fff;
  border-radius: 2px;
}

.index_4_goods_wrap .index_4_goods-price .price-rent .crossed_price {
  color: #999;
  text-decoration: line-through;
  font-weight: 400;
  font-size: 12px;
  padding-left: 3px;
}

.index_4_goods_wrap .index_4_goods-price .price-condition {
  margin-top: 8px;
}

.index_4_goods_wrap .index_4_goods-price .price-least {
  margin-top: 10px;
}

.index_4_goods_wrap .index_4_goods-price .price-least span {
  color: #fc3737;
  font-weight: 700;
}

.index_4_goods_wrap .index_4_goods-price .price-least label {
  font-size: 14px;
}

.index_4_goods_wrap .index_4_goods-price .price-vip {
  text-align: center;
  line-height: 35px;
  color: #222;
  font-weight: 700;
  font-size: 14px;
}

.index_4_goods_wrap .index_4_goods-price .price-vip i {
  background: url(data:image/png;base64,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)
    no-repeat 0 0;
  display: inline-block;
  width: 50px;
  height: 18px;
  vertical-align: middle;
  margin-top: -2px;
  margin-right: 5px;
}

.index_4_goods_wrap .index_4_goods-price .price-coupon {
  font-size: 14px;
  color: #4d4d4d;
  margin-top: 5px;
}

.index_4_goods_wrap .index_4_goods-price .price-coupon .icon {
  height: 16px;
  background: -webkit-gradient(
    linear,
    right top,
    left top,
    from(#ff6d27),
    to(#ff9510)
  );
  background: -webkit-linear-gradient(right, #ff6d27, #ff9510);
  background: -moz-linear-gradient(right, #ff6d27 0, #ff9510 100%);
  background: linear-gradient(270deg, #ff6d27, #ff9510);
  border-radius: 2px;
  display: inline-block;
  color: #fff;
  font-size: 12px;
  line-height: 16px;
  padding: 0 4px;
  vertical-align: 0;
}

.index_4_goods_wrap .goods-control {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.index_4_goods_wrap .carousel {
  width: 648px;
  height: 500px;
  border: 1px solid #bbb;
  position: absolute;
  left: 125px;
  top: 0;
  z-index: 2;
  display: none;
  background: #fff;
  text-align: center;
  -webkit-box-shadow: 1px 1px 5px rgba(24, 8, 8, 0.5);
  box-shadow: 1px 1px 5px rgba(24, 8, 8, 0.5);
}

.index_4_goods_wrap .carousel .slideshow {
  width: 620px;
  height: 410px;
  position: relative;
  overflow: hidden;
  margin: 14px;
}

.index_4_goods_wrap .carousel .slideshow li {
  height: 100%;
  background: #fff;
}

.index_4_goods_wrap .carousel .slideshow li img {
  max-width: 100%;
  border-radius: 1%;
  height: 100%;
}

.index_4_goods_wrap .carousel .swiper-next,
.index_4_goods_wrap .carousel .swiper-prev {
  width: 34px;
  height: 60px;
  position: absolute;
  top: 50%;
  margin-top: -30px;
  cursor: pointer;
  z-index: 2;
}

.index_4_goods_wrap .carousel .swiper-prev {
  left: 0;
  background-position: -127px -68px;
}

.index_4_goods_wrap .carousel .swiper-next {
  right: 0;
  background-position: -203px -69px;
}

.index_4_goods_wrap .carousel .swiper-prev:hover {
  background-position: -165px -68px;
}

.index_4_goods_wrap .carousel .swiper-next:hover {
  background-position: -241px -69px;
}

.index_4_goods_wrap .carousel .swiper-pagination span {
  background: #ccc;
}

.index_4_goods_wrap
  .carousel
  .swiper-pagination
  span.swiper-pagination-bullet-active {
  background: #fc3737;
}

.index_4_goods_wrap .carousel button {
  background: #fc3737;
  color: #fff;
  margin: 22px auto 10px;
}

.index_4_goods_wrap .carousel button .experiencing {
  font-weight: 700;
}

.index_4_goods_wrap .carousel ol {
  width: auto;
}

.index_4_goods_wrap .s_audio {
  position: absolute;
  bottom: 25px;
  left: 20px;
  width: 100px;
  height: 23px;
  background-color: rgba(0, 0, 0, 0.8);
}

.index_4_goods_wrap .s_audio span {
  float: left;
  color: #fff;
}

.index_4_goods_wrap .s_audio .s_time {
  padding: 2px 0 0 5px;
}

.index_4_goods_wrap .s_audio span:last-of-type {
  float: right;
  padding: 2px 5px 0 0;
}

.index_4_goods_wrap .gamename {
  text-align: center;
  margin-left: 15px;
  line-height: 20px;
  padding-top: 6px;
  color: #333;
  font-size: 12px;
  width: 100px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.goods-empty-box {
  text-align: center;
}

.index_4_goods_wrap .goods-info-price .goods-info {
  width: 65%;
}

.index_4_goods_wrap .goods-info-price .goods-info .IntroduceBox {
  display: none;
}

.index_4_goods_wrap .goods-info-price .index_4_goods-price {
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  align-self: center;
}

.index_4_goods_wrap .goods-detail-btn,
.index_4_goods_wrap .goods-game-info .area:before,
.index_4_goods_wrap .hidden_hot,
.index_4_goods_wrap .tj-old-price {
  display: none;
}

.index_4_goods_wrap202306
  .index_4_goods_list
  .goods-info
  .goods-fix-height
  .IntroduceBox
  .IntroduceImg {
  width: 18px;
  height: 18px;
}

.index_4_goods_wrap202306
  .index_4_goods_list
  .goods-info
  .goods-fix-height
  .IntroduceBox
  .IntroduceMes {
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  padding: 0 8px;
  border: 1px solid #ffe5d0;
  color: #a86c3a;
  border-radius: 0 4px 4px 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.ad-ff-previn {
  position: fixed;
  width: 672px;
  height: 542px;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 77;
}

.ad-ff-previn .close {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 24px;
  color: #666;
  border: 1px solid #666;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
}

.index_4_goods_wrap .goods-img-num {
  display: none;
}

.index_4_goods_wrap .goods-info-price .goods-info {
  width: 65%;
}

.index_4_goods_wrap .goods-info-price .index_4_goods-price {
  align-self: center;
}

.index_4_goods_wrap .tj-old-price {
  display: none;
}

.index_4_goods_wrap .goods-game-info .area:before {
  display: none;
}

.index_4_goods_wrap .goods-detail-btn,
.index_4_goods_wrap .hidden_hot {
  display: none;
}

.index_4_goods_wrap.index_4_goods_wrap202306 {
  font-family: PingFang SC, Roboto, Helvetica Neue, Helvetica, Arial,
    Microsoft YaHei, Microsoft Jhenghei, Source Han Sans, sans-serif;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .hidden_hot {
  display: inline;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .index_4_goods_list {
  background: none;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .index_4_goods_list ul > li {
  background: #ffffff;
  border-radius: 4px;
  border-bottom: 1px solid #eee;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .index_4_goods_list ul > li a {
  padding: 16px 20px;
  width: auto;
  border-radius: 4px;
  flex-wrap: wrap;
}

.index_4_goods_wrap.index_4_goods_wrap202306
  .index_4_goods_list
  ul
  > li
  a
  .zuhao-game-detail {
  display: none;
}

.index_4_goods_wrap.index_4_goods_wrap202306
  .index_4_goods_list
  ul
  > li
  a:hover {
  box-shadow: 0 6px 14px #00000014;
  background-color: transparent;
}

.index_4_goods_wrap.index_4_goods_wrap202306
  .index_4_goods_list
  ul
  > li
  a.active
  .zuhao-game-detail {
  display: block;
}

.index_4_goods_wrap.index_4_goods_wrap202306
  .index_4_goods_list
  li.detail-open
  .goods-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  max-height: 46px;
  height: auto;
}

.index_4_goods_wrap.index_4_goods_wrap202306
  .index_4_goods_list
  li.detail-open
  .goods-title
  .goods-title-con {
  white-space: pre-wrap;
}

.index_4_goods_wrap.index_4_goods_wrap202306
  .index_4_goods_list
  li.detail-open
  .goods-game-info {
  margin-top: 6px;
}

/* .index_4_goods_wrap.index_4_goods_wrap202306 .goods-img {
  width: 120px;
  flex: 0 0 120px;
  height: 40px;
  align-self: baseline;
} */

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-img:hover .carousel {
  display: none !important;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-img .phone-system-icon {
  display: none;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-img .goods-img-num {
  position: absolute;
  height: 23px;
  background: rgba(0, 0, 0, 0.72);
  border-radius: 12px 0 0;
  backdrop-filter: blur(1px);
  padding: 0 9px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  right: 0;
  bottom: 0;
  line-height: 23px;
  z-index: 1;
  display: inline-block;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-img .list-img {
  width: 40px;
  height: 40px;
  background: #f3f6fc;
  margin-right: 16px;
  margin-left: 0;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-img .list-img:before {
  content: "";
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: #00000080;
  position: absolute;
  display: none;
  transition: all 0.3s;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-img .list-img:hover:before {
  display: inline-block;
  transition: all 0.3s;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-img .table-img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  display: inline-block;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-control {
  flex: 0 0 115px;
  position: relative;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-control button {
  width: 115px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #ff6b66;
  font-size: 14px;
  line-height: 36px;
  font-weight: 500;
  color: #ff3d3d;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-control button:hover {
  background: #ff3d3d;
  color: #fff;
  box-shadow: none;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-control .btn-hui {
  background: #cdcdcd;
  color: #fff;
  border-color: #cdcdcd;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-control .btn-hui:hover {
  background: #cdcdcd;
  border-color: #cdcdcd;
  color: #fff;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-control .btn-wait {
  background: #ffc4c4;
  color: #fff;
  border-color: #ffc4c4;
  cursor: pointer;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-control .btn-wait:hover {
  background: #ffc4c4;
  color: #fff;
  border-color: #ffc4c4;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-detail-btn {
  display: inline-block;
  position: absolute;
  font-size: 14px;
  font-weight: 400;
  color: #3d8bff;
  line-height: 20px;
  right: 20px;
  bottom: 16px;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-detail-btn:hover {
  color: #296ad9;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-detail-btn .icon-svg {
  width: 14px;
  height: 14px;
  overflow: hidden;
  background: none;
  vertical-align: -1px;
  display: inline-block;
  margin-left: 5px;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-info-price {
  height: 40px;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-fix-height {
  height: 70px;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .index_4_goods-price {
  text-align: left;
  align-self: center;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .index_4_goods-price .price-rent {
  font-size: 20px;
  font-weight: 500;
  color: #262626;
  text-align: center;
  margin-bottom: 10px;
}

.index_4_goods_wrap.index_4_goods_wrap202306
  .index_4_goods-price
  .price-rent
  .price-symbol {
  font-size: 12px;
  display: inline;
}

.index_4_goods_wrap.index_4_goods_wrap202306
  .index_4_goods-price
  .tj-old-price {
  font-size: 12px;
  font-weight: 400;
  color: #999;
  line-height: 12px;
  text-decoration: line-through;
  margin: 2px 0 8px;
}

.index_4_goods_wrap.index_4_goods_wrap202306
  .index_4_goods-price
  .price-coupon {
  height: 16px;
  line-height: 16px;
  border-radius: 4px;
  border: 1px solid #fdada2;
  position: relative;
  padding-left: 48px;
  padding-right: 5px;
  font-size: 12px;
  color: #8e301d;
  display: inline-block;
  margin-top: 2px;
}

.index_4_goods_wrap.index_4_goods_wrap202306
  .index_4_goods-price
  .price-coupon
  .icon {
  position: absolute;
  left: -1px;
  top: -1px;
  padding: 0 4px;
  height: 18px;
  background: linear-gradient(25deg, #f63161 0%, #ffc3ad 100%);
  border-radius: 4px 0 0 4px;
  font-size: 12px;
  font-weight: 400;
  color: #fff;
  line-height: 18px;
}

.index_4_goods_wrap.index_4_goods_wrap202306
  .index_4_goods-price
  .tj-old-price
  + .price-vip-new {
  margin-top: 0;
}

.index_4_goods_wrap.index_4_goods_wrap202306
  .index_4_goods-price
  .tj-old-price
  + .price-coupon {
  margin-top: 0;
}

.index_4_goods_wrap.index_4_goods_wrap202306
  .index_4_goods-price
  .price-condition {
  display: none;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-title {
  height: 40px;
  font-size: 16px;
  color: #262626;
  line-height: 40px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: middle;
  text-align: justify;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-title .summer7 {
  display: none;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-title-con {
  max-width: 100%;
  display: inline;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-title-con:hover {
  color: #ff3d3d;
}

.index_4_goods_wrap.index_4_goods_wrap202306 .goods-rent-times {
  display: none;
}

.law-limit-left {
  float: left;
  display: block;
  width: 88px;
  height: 40px;
  line-height: 40px;
  /* padding-right: 15px; */
  text-align: right;
  color: #888;
}

.se-triangle,
.se-triangle-on {
  width: 6px;
  height: 5px;
  display: inline-block;
  background-position: -31px -53px;
  margin-left: 10px;
  position: relative;
  top: -2px;
}

.se-triangle {
  background-position: -21px -53px;
}

.fr.act_color .se-triangle {
  background-position: -31px -53px;
}

.home-download-icon {
  width: 11px;
  height: 12px;
  background-position: -193px -50px;
  display: inline-block;
  margin-right: 5px;
}

.shq-down-icon {
  width: 12px;
  height: 18px;
  display: inline-block;
  background-position: -209px -51px;
  position: absolute;
  top: 12px;
  left: 64px;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
}

.drawer-fire-icon {
  width: 9px;
  height: 11px;
  display: inline-block;
  background-position: -51px -52px;
  margin-left: 4px;
  -webkit-animation: hot-icon 4s infinite alternate;
  -moz-animation: hot-icon 4s infinite alternate;
  animation: hot-icon 4s infinite alternate;
}
</style>
